import Component from '../app/component';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {};
  }

  init() {
    // load more
    if (this.refs.loadMore) {
      this.refs.loadMore.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.refs.loadMore.href) {
          this.loadMore(this.refs.loadMore.href);
        }
      });
    }

    const scrollY = sessionStorage.getItem('scrollY');
    if (scrollY) {
      window.scrollTo({
        top: parseInt(scrollY, 10)
      });
      sessionStorage.removeItem('scrollY');
    }

    if (this.refs?.filterAll) {
      this.refs.filterAll.addEventListener('click', () => {
        sessionStorage.setItem('scrollY', window.scrollY);
      });
    }

    if (this.refs?.filters?.length) {
      this.refs.filters.forEach((el) => {
        el.addEventListener('click', () => {
          sessionStorage.setItem('scrollY', window.scrollY);
        });
      });
    }
  }

  loadMore(url) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        if (html) {
          const domParser = new DOMParser();
          const doc = domParser.parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('.recipes-item');
          if (items) {
            items.forEach((el) => this.refs.wrapper.appendChild(el));
            this.refs.items = Array.from(this.refs.wrapper.querySelectorAll('.recipes-item'));
          }
          document.dispatchEvent(new CustomEvent('words.parse'));
          document.dispatchEvent(new CustomEvent('detectable.parse'));
          const loadMore = doc.querySelector('.recipes-loadmore');
          if (loadMore) {
            this.refs.loadMore.href = loadMore.href;
          } else {
            this.refs.loadMore.parentNode.removeChild(this.refs.loadMore);
          }
        }
      });
  }
}
